import React, { useEffect, useMemo, useState } from 'react';
import { View, Text, FlatList } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useDispatch, useSelector } from 'react-redux';
import lodash from 'lodash';
import SearchBar from '../../components/SearchBar';
import { LedgerProps } from '../../navigation/condoTypes';
import styles from './styles';
import { selectUserData, fetchUserData } from '../../store/appSlice';
import { RootState } from '../../store/rootReducer';
import { USER_NAME } from '../../lib/constants';
import LedgetItem from './components/LedgerItem';

type Props = {} & LedgerProps;

const LedgerScreen: React.FC<Props> = ({ navigation }) => {
  const dispatch = useDispatch();
  const [userId, setUserId] = useState('');
  const userData = useSelector((state) => selectUserData(state as RootState));

  const ledgers = useMemo(() => {
    let ledgerRaws = lodash.get(userData, 'Ledger.Transaction', []);
    if (!Array.isArray(ledgerRaws) && typeof ledgerRaws === 'object') {
      ledgerRaws = [ledgerRaws];
    }
    // console.log('user data is:', JSON.stringify(userData, null, 2));
    // console.log('ledgerRaws are', ledgerRaws);
    // slice() to fix issue with frozen array
    return (ledgerRaws || []).slice().sort((pre: any, next: any) => {
      const prevLedgerDate = new Date(pre.TransDate);
      const nextLedgerDate = new Date(next.TransDate);
      return (nextLedgerDate as any) - (prevLedgerDate as any);
    });
  }, [userData]);

  React.useEffect(() => {
    AsyncStorage.getItem(USER_NAME).then((value) => setUserId(String(value)));
  }, [navigation, dispatch]);

  React.useEffect(() => {
    if (userId) {
      const unsubscribe = navigation.addListener('focus', () => {
        dispatch(fetchUserData(userId));
      });
      dispatch(fetchUserData(userId));
      // clean up
      return unsubscribe;
    }
  }, [dispatch, navigation, userId]);

  return (
    <View style={styles.container}>
      <SearchBar
        onBackPressed={() => navigation.goBack()}
        enableBack
        placeholder="Ledger"
      />
      {ledgers.length === 0 && (
        <View style={styles.titleNoData}>
          <Text>Ledger data is not available</Text>
        </View>
      )}
      {ledgers.length > 0 && (
        <FlatList
          renderItem={({ item, index }) => (
            <LedgetItem isBrown={index % 2} item={item} />
          )}
          data={ledgers}
          style={styles.flatList}
          keyExtractor={(item) => `${item.TransID}`}
        />
      )}
    </View>
  );
};

export default LedgerScreen;
